import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ProgressBar() {
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState(1);

  // Сопоставление URL с этапами
  const steps = [
    { id: 1, label: "Parks", path: "/0" },
    { id: 2, label: "Tickets", path: "/1" },
    { id: 3, label: "Date", path: "/2" },
    { id: 4, label: "Time", path: "/3" },
    { id: 5, label: "Details", path: "/4" },
    { id: 6, label: "Payment", path: "/5" },
  ];

  // Определение текущего этапа
  useEffect(() => {
    const matchedStep = steps.find((step) => location.pathname.includes(step.path));
    if (matchedStep) {
      setCurrentStep(matchedStep.id);
    }
  }, [location]);

  return (
    <div className="flex items-center justify-center py-6 bg-[#FAF7EC]">
      <div className="flex items-center w-full px-4 space-x-2 overflow-x-auto md:px-0 md:w-auto md:overflow-visible">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            {/* Кружок с номером */}
            <div
              className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full text-white font-bold transition ${
                step.id < currentStep
                  ? "bg-green-700"
                  : step.id === currentStep
                  ? "bg-black"
                  : "bg-gray-300 text-gray-500"
              }`}
            >
              {step.id}
            </div>

            {/* Лейбл (скрывается на мобильных) */}
            <span
              className={`text-xs md:text-sm font-medium transition hidden md:block ${
                step.id <= currentStep ? "text-black" : "text-gray-400"
              }`}
            >
              {step.label}
            </span>

            {/* Линия между элементами */}
            {index < steps.length - 1 && (
              <div
                className={`h-1 flex-1 w-6 md:w-10 transition ${
                  step.id < currentStep ? "bg-green-700" : "bg-gray-300"
                }`}
              ></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
